<template>
  <div class="dialog">
    <div class="card">
      <h1>Project Details</h1>

      <ProjectForm
        :selectedProject="project"
        @hide-dialog="$emit('hide-project-form')"
        @save-project="saveProject"
        @delete-all-users="deleteAllUsers"
      />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import ProjectForm from '@/components/project/ProjectForm.vue'

export default {
  name: 'EditProject',
  props: ['project', 'projectId'],
  components: { ProjectForm },
  methods: {
    saveProject($event) {
      firebase.database().ref(`projects/${this.projectId}`).update($event)
        .then(() => {
          this.$emit('hide-project-form')
        })
    },
    deleteAllUsers() {
        const confirm = window.confirm(`Are you sure you want to delete all of ${this.project.name}'s users?`)
        if (confirm) {
          let usersRef = firebase.database().ref('users')
          usersRef.orderByChild('projectId').equalTo(this.projectId).once('value')
            .then((snapshot) => {
              snapshot.forEach((childSnapshot) => {
                usersRef.child(childSnapshot.key).remove()
              })
              this.$emit('hide-project-form')
            })
        }
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '../../assets/styles/colors';
  @import '../../assets/styles/mixin';
  @import '../../assets/styles/input';
  @import '../../assets/styles/dialog';
  @import '../../assets/styles/card';
</style>



// WEBPACK FOOTER //
// src/components/project/EditProject.vue